import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { EditorContent, useEditor } from '@tiptap/react';
import { TextSelection } from 'prosemirror-state';
import { bioExtensions } from './extensions';
import { bioDocument, serializeBioDoc } from './model';
import './style.scss';

const BioEditor = forwardRef(function BioEditor({ value, onChange, disabled, label, invalid, describedBy }, ref) {
  const editor = useEditor({
    extensions: bioExtensions,
    content: bioDocument(value),
    editable: !disabled,
    editorProps: { attributes: { class: 'profileAbout', role: 'textbox', 'aria-multiline': 'true',
      'aria-label': label, 'aria-describedby': describedBy, 'aria-invalid': String(Boolean(invalid)), 'data-placeholder': label } },
    onUpdate: ({ editor: current }) => onChange(serializeBioDoc(current.state.doc)),
  });
  useImperativeHandle(ref, () => ({ focus() {
    if (!editor || editor.isDestroyed) return;
    editor.view.dispatch(editor.state.tr.setSelection(TextSelection.atEnd(editor.state.doc)));
    // Synchronous focus preserves the user gesture required by mobile Safari.
    editor.view.dom.focus({ preventScroll: true });
  } }), [editor]);
  useEffect(() => {
    if (editor && !editor.isDestroyed) editor.setEditable(!disabled, false);
  }, [editor, disabled]);
  useEffect(() => {
    editor?.view.dom.setAttribute('aria-invalid', String(Boolean(invalid)));
  }, [editor, invalid]);
  // The editor owns the draft for its lifetime; profile/session changes unmount
  // it. Re-parsing each parent render would lose Undo, IME and the caret.
  return <EditorContent editor={editor} className={`profile-bio-editor${editor?.isEmpty ? ' profile-bio-editor--empty' : ''}`} data-placeholder={label} />;
});

export default BioEditor;
